import { HexColorPicker } from 'react-colorful'
import { useState } from 'react'
import { Plus, Trash2 } from 'lucide-react'
import CommonSettings from './CommonSettings'

export default function MenuSettings({ block, onUpdate }) {
  const { settings } = block
  const [showColorPicker, setShowColorPicker] = useState(false)

  const updateLink = (index, field, value) => {
    const newLinks = [...settings.links]
    newLinks[index][field] = value
    onUpdate({ links: newLinks })
  }

  const addLink = () => {
    onUpdate({
      links: [...settings.links, { text: 'New Link', url: '#' }]
    })
  }

  const removeLink = (index) => {
    onUpdate({
      links: settings.links.filter((_, i) => i !== index)
    })
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>Menu Links</h4>

      {settings.links?.map((link, index) => (
        <div key={index} style={{ border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)', padding: '0.75rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
            <label style={{ fontSize: '0.8rem', fontWeight: '500' }}>Link {index + 1}</label>
            <button
              onClick={() => removeLink(index)}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--color-danger)',
                cursor: 'pointer',
                padding: '0'
              }}
            >
              <Trash2 size={14} />
            </button>
          </div>
          <input
            type="text"
            value={link.text}
            onChange={(e) => updateLink(index, 'text', e.target.value)}
            placeholder="Link text"
            style={{ width: '100%', fontSize: '0.85rem', padding: '0.4rem', marginBottom: '0.5rem' }}
          />
          <input
            type="text"
            value={link.url}
            onChange={(e) => updateLink(index, 'url', e.target.value)}
            placeholder="URL"
            style={{ width: '100%', fontSize: '0.85rem', padding: '0.4rem' }}
          />
        </div>
      ))}

      <button
        onClick={addLink}
        className="btn btn-ghost"
        style={{ width: '100%', fontSize: '0.85rem' }}
      >
        <Plus size={16} />
        <span>Add Link</span>
      </button>

      <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>Menu Style</h4>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Orientation
        </label>
        <select
          value={settings.orientation || 'horizontal'}
          onChange={(e) => onUpdate({ orientation: e.target.value })}
          style={{ width: '100%', fontSize: '0.85rem', padding: '0.4rem' }}
        >
          <option value="horizontal">Horizontal</option>
          <option value="vertical">Vertical</option>
        </select>
      </div>

      {settings.orientation === 'horizontal' && (
        <div>
          <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
            Separator
          </label>
          <input
            type="text"
            value={settings.separator || ''}
            onChange={(e) => onUpdate({ separator: e.target.value })}
            onBlur={(e) => {
              if (!e.target.value.trim()) {
                onUpdate({ separator: ' | ' })
              }
            }}
            placeholder="e.g., | (default: ' | ')"
            style={{ width: '100%', fontSize: '0.85rem', padding: '0.4rem' }}
          />
        </div>
      )}

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Font Size
        </label>
        <input
          type="text"
          value={settings.fontSize || ''}
          onChange={(e) => onUpdate({ fontSize: e.target.value })}
          onBlur={(e) => {
            if (!e.target.value.trim()) {
              onUpdate({ fontSize: '14px' })
            }
          }}
          placeholder="e.g., 14px (default: 14px)"
          style={{ width: '100%', fontSize: '0.85rem', padding: '0.4rem' }}
        />
      </div>

      <div style={{ position: 'relative' }}>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Link Color
        </label>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <div
            onClick={() => setShowColorPicker(!showColorPicker)}
            style={{
              width: '40px',
              height: '32px',
              backgroundColor: settings.color || '#007bff',
              border: '1px solid var(--color-border)',
              borderRadius: 'var(--radius-sm)',
              cursor: 'pointer'
            }}
          />
          <input
            type="text"
            value={settings.color || ''}
            onChange={(e) => onUpdate({ color: e.target.value })}
            onBlur={(e) => {
              if (!e.target.value.trim()) {
                onUpdate({ color: '#007bff' })
              }
            }}
            placeholder="#007bff"
            style={{ flex: 1, fontSize: '0.85rem', padding: '0.4rem' }}
          />
        </div>
        {showColorPicker && (
          <div style={{ position: 'absolute', zIndex: 10, marginTop: '0.5rem' }}>
            <div
              style={{ position: 'fixed', inset: 0 }}
              onClick={() => setShowColorPicker(false)}
            />
            <HexColorPicker
              color={settings.color || '#007bff'}
              onChange={(color) => onUpdate({ color })}
            />
          </div>
        )}
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Text Align
        </label>
        <select
          value={settings.textAlign || 'center'}
          onChange={(e) => onUpdate({ textAlign: e.target.value })}
          style={{ width: '100%', fontSize: '0.85rem', padding: '0.4rem' }}
        >
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </div>

      <CommonSettings settings={settings} onUpdate={onUpdate} />
    </div>
  )
}
